import { FormControl as MuiFormControl, styled } from '@mui/material';

import breakpoints from '../../../constants/breakpoints';

export const FormControl = styled(MuiFormControl)(({ theme }) => ({
  [theme.breakpoints.up(breakpoints.tabletS)]: {
    maxWidth: 'var(--preference-search-width-desktop)',
  },
}));
